module.exports = __webpack_public_path__ + "static/images/pick-up.20L3NpX.svg";